import { Schema } from 'effect';
import { BillingInterval, CentAmount, PlanKey } from './billing-status';
import { CheckoutAttribution, ConfirmationType } from './billing-subscribe';

export const AnalyticsDistinctId = Schema.String.check(
  Schema.isMaxLength(200),
  Schema.isPattern(/^[\w.:$-]+$/),
);

export const PendingCheckoutQuoteQuery = Schema.Struct({
  distinct_id: Schema.optional(AnalyticsDistinctId),
});

export const CreatePendingCheckoutRequest = Schema.Struct({
  plan_id: PlanKey,
  expected_amount_cents: CentAmount,
  cf_turnstile_token: Schema.String,
  attribution: Schema.optional(CheckoutAttribution),
});
export type CreatePendingCheckoutRequest = Schema.Schema.Type<
  typeof CreatePendingCheckoutRequest
>;

export const CreatePendingCheckoutResponse = Schema.Struct({
  client_secret: Schema.String,
});
export type CreatePendingCheckoutResponse = Schema.Schema.Type<
  typeof CreatePendingCheckoutResponse
>;

export const PendingCheckoutCard = Schema.Struct({
  brand: Schema.String,
  last4: Schema.String,
});

export const PendingCheckoutState = Schema.Literals([
  'none',
  'awaiting_card',
  'card_saved',
]);
export type PendingCheckoutState = Schema.Schema.Type<
  typeof PendingCheckoutState
>;

export const PendingCheckoutStatus = Schema.Struct({
  state: PendingCheckoutState,
  setup_intent_id: Schema.NullOr(Schema.String),
  plan_id: Schema.NullOr(PlanKey),
  interval: Schema.NullOr(BillingInterval),
  amount_cents: Schema.NullOr(CentAmount),
  trial_days: Schema.NullOr(Schema.Int),
  card: Schema.NullOr(PendingCheckoutCard),
});
export type PendingCheckoutStatus = Schema.Schema.Type<
  typeof PendingCheckoutStatus
>;

export const FinishPendingCheckoutOutcome = Schema.Literals([
  'created',
  'already_subscribed',
  'offer_unavailable',
  'no_pending_checkout',
]);
export type FinishPendingCheckoutOutcome = Schema.Schema.Type<
  typeof FinishPendingCheckoutOutcome
>;

export const FinishPendingCheckoutResponse = Schema.Struct({
  outcome: FinishPendingCheckoutOutcome,
  setup_intent_id: Schema.NullOr(Schema.String),
  subscription_id: Schema.NullOr(Schema.String),
  client_secret: Schema.NullOr(Schema.String),
  confirmation_type: Schema.NullOr(ConfirmationType),
});
export type FinishPendingCheckoutResponse = Schema.Schema.Type<
  typeof FinishPendingCheckoutResponse
>;
